import React from 'react'

const SignupFormContext = React.createContext<any>(null)

export default SignupFormContext
